export default __webpack_public_path__ + "static/media/kg.0371bf59.png";